import { phaseVar } from '@/theme';

export interface PhasePillProps {
  phase: string;
}

// Gate-status pill. The background mixes the phase color with the surface so
// every theme produces a readable, low-noise chip.
export function PhasePill({ phase }: PhasePillProps) {
  const v = phaseVar(phase);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        height: 22,
        background: `color-mix(in oklab, var(${v}) 22%, var(--apm-bg-2))`,
        color: 'var(--apm-ink)',
        borderRadius: 4,
        border: `1px solid color-mix(in oklab, var(${v}) 50%, var(--apm-line))`,
        fontSize: 11.5,
        fontWeight: 500,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: `var(${v})`,
        }}
      />
      {phase}
    </span>
  );
}
